import { checkAuditSteps } from "@/api/commApi/index";
import { MessageBox } from "element-ui";

const list = {};
const fn = function(msg) {
    MessageBox.alert(msg, "无法添加", {
        type: "warning",
        center: true
    });
};

const createItem = function(promise) {
    return {
        status: 'pending',
        promise,
        result: null
    };
};

export default {
    name: "approval",
    bind(el, binding, vnode) {
        // console.log('zzzzzzz', el);
        const params = binding.value;
        const context = vnode.context;
        const replaceFun = function(result) {
            if(!result.success) {
                // 替换之前的方法
                context[params.fn] = fn.bind(context, result.msg);
            }
        };
        if(params && params.name && params.fn && params.params) {
            const key = params.name + JSON.stringify(params.params);
            const item = list[key];

            if(item) {
                if(item.status !== 'pending') {
                    // console.log('aaa');
                    const result = item.result;
                    replaceFun(result);
                }else {
                    item.promise.then(() => {
                        // console.log('bbb');
                    }).catch(() => {
                        context[params.fn] = fn.bind(context, item.result.msg);
                    });
                }
            }else {
                const promise = checkAuditSteps(params.name, params.params).then(res => {
                    const item = list[key];
                    item.result = res;
                    item.promise = null;
                    item.status = 'fulfilled';
                }).catch(err => {
                    const item = list[key];
                    item.result = err;
                    item.promise = null;
                    item.status = 'rejected';
                    replaceFun(err);
                });

                list[key] = createItem(promise);
            }
        }
    }
};
